export default __webpack_public_path__ + "static/media/pdf.11b163c3.svg";